import { FC, useState, ReactNode } from "react"
import Button from "components/Button/Button"
import IconTriangleDown from "assets/img/icon-triangle-down.svg?react"

interface ICollapsibleSectionProps {
    title: string
    children: ReactNode
    defaultExpanded?: boolean
    className?: string
    titleClassName?: string
}

const CollapsibleSection: FC<ICollapsibleSectionProps> = ({
    title,
    children,
    defaultExpanded = true,
    className = "",
    titleClassName = "",
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded)

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded)
    }

    return (
        <div className={className}>
            <div className={`pl-2 ${titleClassName}`}>
                <Button
                    theme="link"
                    label={title}
                    icon={
                        <div style={{ transform: isExpanded ? 'none' : 'rotate(-90deg)', transition: 'transform 0.2s ease' }}>
                            <IconTriangleDown />
                        </div>
                    }
                    iconPosition="start"
                    size="small"
                    onClick={toggleExpanded}
                    className="text-left color-black"
                />
            </div>
            {isExpanded && (
                <div className="mt-2">
                    {children}
                </div>
            )}
        </div>
    )
}

export default CollapsibleSection
